/**
 * Copyright 2023, Stadtplanungsamt Frankfurt a.M., Stadt Jena
 * All rights reserved.
 *
 * Plugin 'ThemeUsernameTopbar':
 * ===========================
 * Optional aktuelles Thema und/oder angemeldeter Benutzer in der Topbar anzeigen.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {setCurrentTask} from '../../qwc2/actions/task';
import './style/ThemeUsernameTopbar.css';


class ThemeUsernameTopbar extends React.Component {
    static propTypes = {
        currentTheme: PropTypes.object,
        setCurrentTask: PropTypes.func,
        state: PropTypes.object,
        showThemeName: PropTypes.bool,
        showUserName: PropTypes.bool
    }
    static defaultProps = {
        showThemeName: true,    // true: zeige in Topbar, false: nichts zeigen
        showUserName: true      // true: zeige in Topbar, false: nichts zeigen
    }
    constructor(props) {
        super(props);
    }

    // Zeichnen des Plugins:
    render() {
        if (this.props.currentTheme.title === undefined) return null;
        let currentThemeTitle = this.props.currentTheme.title
        let userInfoText = ""
        let themeInfoText = ""
        let username = this.props.user_name  // Kommt aus [state.localConfig.username], siehe ganz unten
        let theme_id = "current_user_theme";
        let theme_className = "theme";

        // Infos bei Mouseover
        if (this.props.showThemeName && currentThemeTitle != "") {
            themeInfoText = (
                'Aktuelles Kartenthema: ' + currentThemeTitle
            );
        }
        if (this.props.showUserName && username != "") {
            userInfoText = (
                'Angemeldet als ' + username
            );
        }

        // Thema anzeigen?
        let theme_in_topbar = null;
        if (this.props.showThemeName) {
            theme_in_topbar = (
                <span className={theme_className} title={themeInfoText}>{currentThemeTitle}</span>
            )
        }

        // Nutzername anzeigen?
        let login_username = null;
        if (this.props.showUserName) {
            if (username != "") {
                login_username = (
                    <span className={theme_className} title={userInfoText}>{username}</span>
                )
            }
        }

        // Thema und / oder Nutzermane zeigen
        let theme_username = null;
        if (theme_in_topbar != null) {
            if (login_username != null) {
                theme_username = (
                    <div id="theme_username">
                        <div id={theme_id}>
                            {theme_in_topbar} | {login_username}
                        </div>
                    </div>
                );
            }
            else {
                theme_username = (
                    <div id="theme_username">
                        <div id={theme_id}>
                            {theme_in_topbar}
                        </div>
                    </div>
                );
            }
        }
        else {
            if (login_username != null) {
                theme_username = (
                    <div id="theme_username">
                        <div id={theme_id}>
                            {login_username}
                        </div>
                    </div>
                );
            }
        }

        return (
            <div>
                {theme_username}
            </div>
        );
    }
};

const selector = (state) => ({
    currentTheme: state.theme.current || {},
    user_name: state.localConfig.username || "",
    state: state
});

export default connect(selector, {
    setCurrentTask: setCurrentTask
})(ThemeUsernameTopbar);
